var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    viewBox: "0 0 64 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3879 2.3335C62.0894 2.33362 62.4728 2.85718 62.6233 3.15088C62.7953 3.48677 62.8694 3.87757 62.8694 4.24365V29.1479C62.8694 29.511 62.794 29.8951 62.6204 30.2231C62.4768 30.4943 62.0949 31.0089 61.4114 30.9985V30.9995H31.5364V4.24365C31.5364 3.84914 31.6187 3.44832 31.804 3.10986C31.9687 2.80903 32.3571 2.3335 33.0188 2.3335H61.3879Z",
    fill: "#06BFFC",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8926 30.8467H2.9502C1.81485 30.8467 1 29.9227 1 28.8965V2.9043C1 1.84626 1.84627 1 2.9043 1H11.1494C22.0471 1 30.828 9.79964 30.8926 20.6455V30.8467Z",
    fill: "#0063FC",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinn);
export default __webpack_public_path__ + "static/media/finn.afa96081f7fccc336709f6b5a7838618.svg";
export { ForwardRef as ReactComponent };